import { useDisclosure } from "@mantine/hooks";
import { LockResetOutlined } from "@mui/icons-material";
import {
    ActionsMenu,
    ActionsMenuItemProps,
    ResetPasswordModal,
    showSuccessNotification,
    useActivateUserMutation,
    useDeactivateUserMutation,
    useDeleteUserMutation
} from "@therapprove/common";
import { FC } from "react";

type TeamActionsMenuProps = {
    userId: string;
    email: string;
    name: string;
    isActive: boolean;
};

export const TeamActionsMenu: FC<TeamActionsMenuProps> = ({
    userId,
    email,
    name,
    isActive
}) => {
    // Mutations
    const [, activateUser] = useActivateUserMutation();
    const [, deactivateUser] = useDeactivateUserMutation();
    const [, deleteUser] = useDeleteUserMutation();

    // State
    const [
        resetPasswordOpened,
        { open: openResetPassword, close: closeResetPassword }
    ] = useDisclosure(false);

    // Handlers
    const handleActiveStatus = async () => {
        if (isActive) {
            await deactivateUser({ userId });
        } else {
            await activateUser({ userId });
        }
        showSuccessNotification(
            `${name} ${isActive ? "deactivated" : "activated"}`
        );
    };

    const handleDelete = async () => {
        await deleteUser({ userId });
        showSuccessNotification(`${name} was deleted`);
    };

    // Menu options
    const menuOptions: ActionsMenuItemProps[] = [
        {
            icon: LockResetOutlined,
            text: "Reset Password",
            onClick: (e) => {
                e.stopPropagation();
                openResetPassword();
            }
        }
    ];

    return (
        <>
            <ResetPasswordModal
                userId={userId}
                email={email}
                opened={resetPasswordOpened}
                close={closeResetPassword}
            />
            <ActionsMenu
                entityId={userId}
                style={{ marginLeft: 0 }}
                onClickEdit={() => {}}
                isActive={isActive}
                allowEdit
                allowDeactivate
                allowDelete
                menuOptions={menuOptions}
                handleActiveStatus={handleActiveStatus}
                handleDelete={handleDelete}
            />
        </>
    );
};
